import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TwilioService {
  private apiUrl = '';

  constructor(private http: HttpClient) {}

  sendSMS(phoneNumber: string, message: string): Observable<any> {
    return this.http.post(this.apiUrl, { phoneNumber, message });
  }
}
